import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

function Checkbox({ id, disabled = false, callBack = () => {alert('not implemented')}, label = 'Label', isChecked = false }) {

  function toggle() {
    isChecked = !isChecked;
    if(callBack)
      callBack(isChecked, id);
  }

  return (
    <div className="wrapper">
      <input 
        id={`checkbox-person-template-#${id}`}
        className="styled-checkbox"
        type="checkbox" 
        checked={isChecked}
        disabled={disabled}
        alt={label}
        onChange={toggle}/>
      <label htmlFor={`checkbox-person-template-#${id}`} alt={label}>{label}</label>
    </div>
  );
}

Checkbox.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  callBack: PropTypes.func.isRequired
};

export default Checkbox;
